export const formErrorMessages = {
  common: {
    required: 'This information is required',
    invalid: 'This value is not valid',
    numeric: 'This value must be numeric',
    maxChar: 'This value cannot be greater than ',
    maxLengthErrorMessage: 'The input has exceeded the maximum length allowed',
    maxArray: 'This value has exceeded the maximum number of records allowed',
    invalidOperator: 'Select Exact to search using multiple Subscriber Numbers'
  },
  date: {
    invalid: 'Please enter a valid date in MM/DD/YYYY format',
    notAfterToDate: '"From" date cannot be after "To" date',
    notBeforeFromDate: '"To" date cannot be before "From" date',
  },
  email: {
    invalid: 'Please enter a valid email address',
  },
  password: {
    invalid:
      `The password must include at least:</br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;One uppercase letter</br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;One lowercase letter</br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;One number</br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;One special character (!@#$%^&amp;+=*)</br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;8 characters</br>
        Your password cannot include any part of your email.`
  },
  months: {
    invalid: 'This value must be a number between 0 and 1000'
  }
};
